import { couponShareService } from '@/api'
import { AsyncRequest } from '@/utils/request'
const state = {
  loading: true,
  title: '领取优惠券',
  couponList: [],
  couponInfo: {},
  message: '',
  receiveInfo: {} // 优惠券领取成功信息
}

const getters = {
  couponList: state => state.couponList,
  couponInfo: state => state.couponInfo,
  title: state => state.title,
  loading: state => state.loading,
  message: state => state.message,
  receiveInfo: state => {
    const receiveInfo = localStorage.getItem('receiveInfo') || null;
    if (state.receiveInfo && state.receiveInfo.isGoodsSale) return state.receiveInfo;
    else return receiveInfo && receiveInfo.length > 5 ? JSON.parse(receiveInfo) : {}
  }
}

const mutations = {
  upList: (state, list) => {
    state.couponList = list
  },
  couponState: (state, obj) => {
    state.couponInfo = obj
    state.title = obj.shareName
    state.message = obj.message
  },
  upLoading: (state, bool) => {
    state.loading = bool
  },
  errorMessage: (state, message) => {
    state.message = message
  },
  receiveSuccess: (state, obj) => {
    localStorage.setItem('receiveInfo', JSON.stringify(obj))
    state.receiveInfo = obj;
  }
}

const actions = {
  // 获取列表
  getList({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => couponShareService.getCouponListByLink(data),
      resolve: (res) => {
        commit('upList', res.couponData);
        commit('couponState', res);
        commit('upLoading', false)
      },
      reject: () => {
        commit('upLoading', false)
        commit('errorMessage', '暂无优惠券')
        // toast(error)
      }
    })
  },
  // 领取
  obtainCouponByLink({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => couponShareService.obtainCouponByLink(data),
      resolve: (res) => {
        commit('receiveSuccess', res)
      },
      reject: () => {
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

